import { render } from "./Toasts.vue?vue&type=template&id=52a62d63"
import script from "./Toasts.vue?vue&type=script&lang=js"
export * from "./Toasts.vue?vue&type=script&lang=js"
script.render = render

export default script